import * as core from '../../../../../../../core'

import { query } from './outcomes-tree-editor.query'

export const RESOURCE = {
  payload: {
    alias: 'summit.outcomes-tree-editor',
    description:
      "Chart used to explore and manage the institution's goals, objectives, and other outcomes",
    name: 'Summit - Outcomes Chart',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
